import { IFile } from '@newroom-connect/library/interfaces';
import { Dimensions } from '@newroom-connect/library/types';

export class ImageHelper {
  private static readonly MINIMUM_PANORAMA_RESOLUTION = 8192;
  private static readonly MAXIMUM_PANORAMA_RESOLUTION = 16384;

  public static readonly DEFAULT_BACKGROUND_URL = '/assets/images/cloud_bg.png';

  /**
   * Check if image is panorama by calculating if width and height match 2:1 aspect ratio.
   *
   * @param resolution
   * @param resolution.width
   * @param resolution.height
   *
   * @returns Indicator, if image is panorama.
   */
  public static isPanoramaImage(resolution: Dimensions): boolean {
    return resolution.width === (resolution.height * 2);
  }

  /**
   * Check by the given resolution, if the image would be supported as a cube map.
   *
   * @param resolution
   * @param resolution.width
   * @param resolution.height
   *
   * @returns Indicator, if image is supported as cube map.
   */
  public static isCubeMapSupported(resolution: Dimensions): boolean {
    return resolution.width >= ImageHelper.MINIMUM_PANORAMA_RESOLUTION && resolution.width <= ImageHelper.MAXIMUM_PANORAMA_RESOLUTION && ImageHelper.isPanoramaImage(resolution);
  }

  /**
   * Checks if given dimensions meet the aspect-ratio requirements.
   *
   * @param file
   * @param expectedWidth
   * @param expectedHeight
   * @param tolerance Acceptable difference between actual and expected aspect ratios.
   *
   * @returns
   */
  public static doesImageMeetDimensions(file: IFile, expectedWidth = 1920, expectedHeight = 1080, tolerance = 0.01): boolean {
    if (!file.width || !file.height) {
      return false;
    }

    const actualRatio = file.width / file.height;
    const expectedRatio = expectedWidth / expectedHeight;

    return Math.abs(actualRatio - expectedRatio) <= tolerance;
  }
}
